import { useNotification } from "@context/NotificationContext";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.sequences.notifications`;

export const useValidationToast = () => {
  const { t } = useTranslation();
  const { notify } = useNotification();
  return () =>
    notify({
      type: "error",
      title: t(`${L}.request-submitted-error-title`),
      description: t(`${L}.request-submitted-error-description`),
    });
};
